"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageSizeSelect = exports.PagenationBySize = void 0;
exports.pagenate = pagenate;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var Pagination_1 = __importDefault(require("semantic-ui-react/dist/commonjs/addons/Pagination/Pagination"));
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
exports.PagenationBySize = React.memo(function (_a) {
    var page = _a.page, pageSize = _a.pageSize, setPage = _a.setPage, length = _a.length, lang = _a.lang;
    var onPageChange = setPage
        ? function (_, _a) {
            var activePage = _a.activePage;
            return setPage(activePage);
        }
        : undefined;
    var totalPages = Math.ceil(length / pageSize);
    if (!page)
        page = 1;
    if (page && page > totalPages && setPage) {
        page = totalPages;
        setPage(page);
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Responsive, { as: "span", minWidth: 992, children: (0, jsx_runtime_1.jsx)(Pagination_1.default, { activePage: page, onPageChange: onPageChange, totalPages: totalPages }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Responsive, { as: "span", maxWidth: 991, children: [i18n_1.default.page, (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Select, { compact: true, value: page, options: Array.from({ length: totalPages }).map(function (_, i) { return ({
                            text: (i + 1).toString(),
                            value: i + 1,
                        }); }), onChange: function (_, _a) {
                            var value = _a.value;
                            return (setPage ? setPage(value) : true);
                        } })] })] }));
});
var pageSizes = [1, 4, 20, 40, 100, 200, 500, 1000];
exports.PageSizeSelect = React.memo(function (_a) {
    var pageSize = _a.pageSize, setPageSize = _a.setPageSize, lang = _a.lang;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Select, { compact: true, defaultValue: pageSize, options: pageSizes.map(function (_pageSize) { return ({ text: _pageSize, value: _pageSize }); }), onChange: function (_, _a) {
                    var value = _a.value;
                    return setPageSize(value);
                } }), i18n_1.default.perPage] }));
});
function pagenate(items, page, pageSize) {
    if (!pageSize)
        return items;
    if (!page)
        page = 1;
    var totalPages = Math.ceil(items.length / pageSize);
    if (page > totalPages)
        page = totalPages;
    return items.slice((page - 1) * pageSize, page * pageSize);
}
